import { useRecoilState } from "recoil";
import { mobileCurrentPage, pdfPage, mobileInputPage } from "../atoms";

const useMobilePageNavigation = () => {
  const [currentPage, setCurrenPage] = useRecoilState(mobileCurrentPage);
  const [numPages, setNumPages] = useRecoilState(pdfPage);
  const [inputValue, setInputValue] = useRecoilState(mobileInputPage);

  const moveToPage = (direction) => {
    const newPage = Math.max(
      1,
      Math.min(
        direction === "next"
          ? currentPage + 1
          : direction === "prev"
          ? currentPage - 1
          : direction === "home"
          ? 1
          : numPages,
        numPages
      )
    );

    setCurrenPage(newPage);
    setInputValue(newPage);
  };

  return {
    currentPage,
    numPages,
    inputValue,
    moveToPage,
    setCurrenPage,
    setNumPages,
    setInputValue,
  };
};

export default useMobilePageNavigation;
